/**
 * Cookie consent – single source of truth.
 * Google Analytics may only load after the visitor has allowed statistics.
 */

export interface CookiePreferences {
  necessary: true;
  analytics: boolean;
  marketing: false; // not used today
}

const STORAGE_KEY = 'cookieConsent';
export const OPEN_COOKIE_SETTINGS_EVENT = 'adgs:open-cookie-settings';

export const readConsent = (): CookiePreferences | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return { necessary: true, analytics: parsed.analytics === true, marketing: false };
  } catch {
    return null;
  }
};

export const saveConsent = (analytics: boolean): CookiePreferences => {
  const prefs: CookiePreferences = { necessary: true, analytics, marketing: false };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
  } catch {
    // storage blocked: the choice applies to this page view only
  }
  return prefs;
};

export const hasAnalyticsConsent = (): boolean => readConsent()?.analytics === true;

/** Lets any link (e.g. in the footer) reopen the cookie settings. */
export const openCookieSettings = (): void => {
  window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS_EVENT));
};
